<div class="building-admin-panel">
  @if (visible()) {
    <div class="header">
      <h3>Gestão de prédio/andar — {{ buildingId }}</h3>
    </div>
    <div class="content">
      <form class="mesa-search-form" (submit)="$event.preventDefault()">
        <label for="mesaSearch">Bloqueio de mesas</label>
        <div class="mesa-search-row">
          <tds-text-field
            id="mesaSearch"
            class="mesa-search-input"
            type="text"
            size="lg"
            state="default"
            label-position="no label"
            no-min-width
            [value]="searchTerm()"
            (input)="searchTerm.set($any($event.target).value)"
            placeholder="M31">
          </tds-text-field>
          <label class="locked-toggle-label">
            <span>Bloqueadas</span>
            <tds-toggle
              [checked]="showLockedOnly()"
              (tdsToggle)="showLockedOnly.set(!!$event.detail.checked)">
            </tds-toggle>
          </label>
        </div>
      </form>
      <div class="mesa-list">
        @for (seat of filteredDesks(); track seat.table_id) {
          <div class="mesa-list-row"
               (mouseenter)="hoverDesk.emit(seat.name || seat.table_id.toString())"
               (mouseleave)="hoverDesk.emit(null)"
               (click)="toggleSelect(seat, $event)">
            <div class="mesa-list-checkbox">
              <input 
                type="checkbox"
                [checked]="selectedDesks.has(seat.table_id)"
                (click)="$event.stopPropagation()"
                (change)="toggleSelectFromCheckbox(seat, $event)">
            </div>
            <div class="mesa-list-id">{{ seat.name || seat.table_id }}</div>
            <div class="mesa-list-periodo">
              {{ (seat.start_date && seat.end_date) ? ('De ' + (seat.start_date | date:'dd-MM-yyyy') + ' Até: ' + (seat.end_date | date:'dd-MM-yyyy')) : (seat.active ? 'Indeterminado' : '') }}
            </div>
            <div class="mesa-list-status">
              {{ seat.active ? 'Com bloqueio' : 'Sem bloqueio' }}
            </div>
          </div>
        }
      </div>
      <tds-button
        type="button"
        variant="primary"
        size="xs"
        text="Opções de bloqueio"
        fullbleed
        animation="none"
        (click)="confirmSelected()"
      ></tds-button>
      
      <tds-divider class="section-divider" orientation="horizontal" variant="subtle"></tds-divider>

      <div class="access-block">
        <label>Área(s) Permitida(s)</label>
        <tds-text-field
          class="text-field-access-block"
          type="text"
          size="lg"
          state="default"
          label-position="no label"
          no-min-width
          [value]="departmentInput"
          (input)="onDepartmentInput($event)"
          (keydown)="onDepartmentKeydown($event)"
          placeholder="Digite uma área e pressione Enter"
          [attr.required]="selectedSection?.blocked ? 'true' : null"
          autocomplete="off">
        </tds-text-field>

        <div class="selected-areas" *ngIf="selectedAreas.length">
          <tds-chip
            *ngFor="let area of selectedAreas"
            type="checkbox"
            size="lg"
            checked
            [value]="area.value"
            [attr.tds-aria-label]="'Remover ' + area.label"
          >
            <span slot="label">{{ area.label }}</span>

            <tds-icon
              slot="suffix"
              name="cross"
              size="16px"
              (click)="removeArea(area.value)"
            ></tds-icon>
          </tds-chip>
        </div>
      </div>

      <div class="except-block">
        <label>Exceções</label>
        <tds-text-field
          class="text-field-except-block"
          type="text"
          size="lg"
          state="default"
          label-position="no label"
          no-min-width
          [value]="exceptionsInput"
          (input)="onExceptionInput($event)"
          (keydown)="onExceptionKeydown($event)"
          placeholder="Digite um usuário e pressione Enter"
          required="false"
          autocomplete="off">
        </tds-text-field>
        <div class="selected-exceptions" *ngIf="selectedExceptions.length">
          <tds-chip
            *ngFor="let exception of selectedExceptions"
            type="checkbox"
            size="lg"
            checked
            [value]="exception.value"
            [attr.tds-aria-label]="'Remover ' + exception.label"
          >
            <span slot="label">{{ exception.label }}</span>

            <tds-icon
              slot="suffix"
              name="cross"
              size="16px"
              (click)="removeException(exception.value)"
            ></tds-icon>
          </tds-chip>
        </div>
        
        <div class="config-toggle-row">
          <label class="toggle-label">
            <span>Private</span>
            <tds-toggle
              [checked]="selectedSection?.blocked || false"
              (tdsToggle)="selectedSection && (selectedSection.blocked = !!$event.detail.checked); checkForChanges()">
            </tds-toggle>
          </label>
          <label class="toggle-label">
            <span>Check-in</span>
            <tds-toggle
              [checked]="selectedSection?.checkin || false"
              (tdsToggle)="selectedSection && (selectedSection.checkin = !!$event.detail.checked); checkForChanges()">
            </tds-toggle>
          </label>
        </div>
        <div class="access-toggles">
          <tds-button
            type="button"
            variant="primary"
            size="xs"
            text="Salvar"
            animation="none"
            [disabled]="!isSaveAllowedAreasEnabled()"
            (click)="saveSectionConfig()"
          ></tds-button>
        </div>
      </div>

      <tds-divider class="section-divider" orientation="horizontal" variant="subtle"></tds-divider>
      <div class="comunicados-block">
        <label>Comunicados</label>
        <div class="communication-dates-row">
          <tds-datetime 
          class="flex-field"
          [value]="statementStart" 
          (change)="statementStart = $any($event.target).value; checkCommunicationChanges()"
          type="date">
        </tds-datetime>
          <tds-datetime 
          class="flex-field"
          [value]="statementEnd" 
          (change)="statementEnd = $any($event.target).value; checkCommunicationChanges()"
          type="date">
        </tds-datetime>
        </div>
        <tds-textarea 
          class="communication-textarea"
          [value]="statement" 
          (change)="statement = $any($event.target).value; checkCommunicationChanges()"
          rows="2">
        </tds-textarea>
        <div class="communication-actions">
          <tds-button
            type="button"
            variant="primary"
            size="xs"
            text="Salvar Comunicado"
            animation="none"
            [disabled]="!isSaveCommunicationEnabled()"
            (click)="saveCommunication()"
          ></tds-button>
          <tds-button
            type="button"
            variant="danger"
            size="xs"
            text="Remover Comunicado"
            animation="none"
            (click)="removeCommunication()"
          ></tds-button>
        </div>
      </div>
    </div>
  }
</div>
<!-- Block Modal -->
<tds-modal
#adminModalMesaBloqueio
  header="Opções de bloqueio"
  size="lg"
  actions-position="static"
  [prevent]="false"
  [closable]="true"
  tds-alert-dialog="dialog"
>
    <span slot="body" class="block-modal-body">
      <!-- Mesas selecionadas -->
      <div>
        <label>Mesas selecionadas</label>
        <tds-text-field
          class="full-width-field"
          type="text"
          size="lg"
          state="default"
          label-position="no label"
          no-min-width
          [value]="blockModalMesasInput"
          disabled
          placeholder="Mesas selecionadas">
        </tds-text-field>
      </div>

      <!-- Toggle e datas -->
      <div class="block-modal-row">
        <div class="flex-field">
          <label class="block-modal-toggle-label">
            <span>Ativar bloqueio</span>
            <tds-toggle
              [checked]="blockModalToggle"
              (tdsToggle)="blockModalToggle = !!$event.detail.checked">
            </tds-toggle>
          </label>
        </div>
      </div>

      <!-- Indeterminado checkbox -->
      <div>
        <label class="block-modal-toggle-label">
          <tds-checkbox
            [checked]="blockModalIndeterminado"
            (change)="blockModalIndeterminado = !!$any($event.target).checked">
          </tds-checkbox>
          <span>Indeterminado</span>
        </label>
      </div>

      <!-- Data Início e Fim -->
      @if (!blockModalIndeterminado) {
        <div class="block-modal-date-row">
          <div class="flex-field">
            <label>Data Início</label>
            <tds-datetime
              class="full-width-field"
              [value]="blockModalDataInicio"
              (change)="blockModalDataInicio = $any($event.target).value"
              [min]="minDataInicio"
              type="date">
            </tds-datetime>
          </div>
          <div class="flex-field">
            <label>Data Fim</label>
            <tds-datetime
              class="full-width-field"
              [value]="blockModalDataFim"
              (change)="blockModalDataFim = $any($event.target).value"
              [min]="minDataFim"
              type="date">
            </tds-datetime>
          </div>
        </div>
      }

      <!-- Mesas com usuário -->
      <div>
        <label>Mesas</label>
        <tds-table vertical-dividers="true" compact-design="false" responsive="true">
          <tds-table-header>
            <tds-header-cell
              cell-key="mesa"
              cell-value="Mesa"
              disable-padding="false"
              text-align="center"
            ></tds-header-cell>
            <tds-header-cell
              cell-key="username"
              cell-value="Usuário/Motivo"
              disable-padding="false"
              text-align="center"
            ></tds-header-cell>
          </tds-table-header>
          <tds-table-body>
            @for (mesa of selectedDesksArray; track mesa.table_id) {
              <tds-table-body-row>
                <tds-body-cell
                  cell-key="mesa"
                  disable-padding="false"
                  text-align="center"
                >
                  {{ mesa.name }}
                </tds-body-cell>
                <tds-body-cell
                  cell-key="username"
                  disable-padding="false"
                  text-align="center"
                >
                  <input
                    type="text"
                    class="text-field-input text-field-input-lg sc-tds-text-field full-width-field"
                    [value]="mesa.username"
                    (input)="mesa.username = $any($event.target).value.substring(0, 29)"
                    placeholder="Usuário/Motivo"
                    maxlength="29"/>
                </tds-body-cell>
              </tds-table-body-row>
            }
          </tds-table-body>
        </tds-table>
      </div>

      <!-- Dias da semana (chips) -->
      <div>
        <label class="block-modal-weekdays-label">Dias da semana</label>
        <div role="group" class="block-modal-weekdays">
          @for (dia of blockModalDiasWeek; track dia.dia) {
            <tds-chip
              type="checkbox"
              size="lg"
              [checked]="dia.checked"
              [disabled]="blockModalIndeterminado"
              [value]="dia.dia"
              (change)="dia.checked = !!$any($event.target).checked">
              <span slot="label">{{ dia.label }}</span>
            </tds-chip>
          }
        </div>
      </div>

      <!-- Observações -->
      <div>
        <label>Observações</label>
        <tds-textarea
          class="full-width-field"
          [value]="blockModalObservacoes"
          (change)="blockModalObservacoes = $any($event.target).value"
          rows="3"
          placeholder="Digite suas observações...">
        </tds-textarea>
      </div>
    </span>

    <span slot="actions" class="tds-u-flex tds-u-gap2">
      <tds-button
        data-dismiss-modal
        size="md"
        text="Cancelar"
        variant="secondary"
        (click)="showBlockModal.set(false)">
      </tds-button>
      <tds-button
        size="md"
        text="Remover Bloqueio"
        variant="danger"
        [disabled]="!hasBlockedSelection()"
        (click)="removeBlockDesk()">
      </tds-button>
      <tds-button
        data-dismiss-modal
        size="md"
        text="Confirmar Bloqueio"
        variant="primary"
        [disabled]="!isConfirmBlockEnabled()"
        (click)="confirmBlockDesk()">
      </tds-button>
    </span>
  </tds-modal>